import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { compose, lifecycle, branch, renderNothing } from 'recompose'
import * as RuleActions from 'app/modules/rules/actions'
import * as RuleSelectors from 'app/modules/rules/selectors'
import { RuleLink } from './RuleLink'

const makeMapStateToProps = () => {
  const rule = RuleSelectors.makeRule()

  return (state, props) => ({
    rule: rule(state, props)
  })
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      fetchRules: RuleActions.fetchRules
    }, dispatch)
  }
}

const componentLifecycle = {
  componentDidMount() {
    this.props.actions.fetchRules()
  }
}

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  lifecycle(componentLifecycle),
  branch((props) => !props.rule, renderNothing),
)(RuleLink)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/RuleLink/index.js